import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import moment from 'moment';
import nl2br from 'react-newline-to-break';
import {Row} from '../common/Row';

export default class RowJobApply extends Row {
    constructor(props) {
        super(props);
        this.renderClass = this.renderClass.bind(this);
        this.renderFilting1 = this.renderFilting1.bind(this);
        this.renderFilting2 = this.renderFilting2.bind(this);
        this.renderFilting3 = this.renderFilting3.bind(this);
    }

    renderClass(){
        let className = '';
        //応募が発生した時
        if(this.props.data['is_not_new']){
            className = 'clickable'
        } else {
            className = 'tr_new_apply clickable'
        }
        //採用した応募の勤務終了時間になった時
        if(this.props.data['is_must_evaluate']){
            className = className + ' is_must_evaluate'
        }
        //応募にコメントがあった時
        if(this.props.data['is_new_msg']){
            className = className + ' is_new_msg'
        }
        return className;
    }

    renderFilting1(){
        if(this.props.data['is_not_new']){
            return '';
        } else {
            return(
                <span className="filting_is_not_new">新応募</span>
            )
        }
    }
    renderFilting2(){
        if(this.props.data['is_must_evaluate']){
            return(
                <span className="filting_is_must_evaluate">評価待ち</span>
            )
        } else {
            return '';
        }
    }
    renderFilting3(){
        if(this.props.data['is_new_msg']){
            return(
                <span className="filting_is_new_msg">新メッセージ</span>
            )
        } else {
            return '';
        }
    }

    render() {
        return (
                <tr className={this.renderClass()} onClick={this.props.removeClick ? null : this.handleEdit}>
                    {this.props.header.map((item, i) =>{
                        var pre = item.hasOwnProperty('prefix')?item.prefix:'';
                        var suff = item.hasOwnProperty('suffix')?item.suffix:'';
                        if(item.type == 'date'){
                                return(
                                        <td key={i} data-label={item.title}>{this.props.data[item.name] != null? this.formatDate(this.props.data[item.name], 'Y年M月D日'):'' }</td>
                                )
                        } else if (item.type == 'date_time') {
                                return(
                                        <td key={i} data-label={item.title}>{this.props.data[item.name] != null? this.formatDate(this.props.data[item.name], 'Y年M月D日 h:m'):'' }</td>
                                )
                        } else if (item.type == 'text_break_line') {
                                return(
                                        <td key={i} data-label={item.title}>{nl2br(this.props.data[item.name])}
                                        </td>
                                        )
                        } else if (item.type == 'status_option') {
                                return(
                                        <td key={i} data-label={item.title}><strong className={item.option[this.props.data[item.name]]['classHTML']}>{item.option[this.props.data[item.name]]['text']}</strong>
                                        </td>
                                        )
                        } else if (item.type == 'text_limit') {
                                return(
                                        <td key={i} data-label={item.title}>
                                            <span className="width-limit">{this.props.data[item.name]}</span>
                                        </td>
                                        )
                        } else if (item.type == 'convert_to_number') {
                                return(
                                        <td key={i} data-label={item.title}>
                                            {this.props.data[item.name] ? pre + parseInt(this.props.data[item.name]).toLocaleString() + suff : ''}
                                        </td>
                                        )
                        } else if (item.type == 'filting') {
                                return(
                                        <td key={i} data-label={item.title}>
                                            {this.renderFilting1()}
                                            {this.renderFilting2()}
                                            {this.renderFilting3()}
                                        </td>
                                    )
                        } else if (item.type == 'age') {
                                var age = moment().diff(this.props.data[item.name], 'years');
                                return <td key={i} data-label={item.title}>{age ? pre + age + suff : '-' }</td>
                        } else if (item.type == 'confirmed_at') {
                            return (
                                <td key={i} data-label={item.title}>
                                    {this.props.data[item.name] ?
                                    <span class="icon-identification font-weight-normal">本人認証済</span>
                                    : ''}
                                </td>
                            )
                        } else {
                                var cel = this.props.data[item.name] == null ? '-':this.props.data[item.name];
                                return(
                                        <td key={i} data-label={item.title}>{ pre + cel + suff}</td>
                                )
                        }
                        })
                    }
                </tr>
                );
    }
}
